import React from 'react';

const styles = {
  open: 'bg-zinc-100 text-zinc-900 border-zinc-900',
  in_progress: 'bg-[#FFD700] text-zinc-900 border-zinc-900',
  resolved: 'bg-black text-white border-black',
};
const labels = { open: 'OPEN', in_progress: 'IN PROGRESS', resolved: 'RESOLVED' };

export default function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center border px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.15em] ${styles[status] || styles.open}`}
    >
      {labels[status] || 'OPEN'}
    </span>
  );
}
